// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Hide the browser's default checkbox */
/*.mimetika-policy .label-checkbox{*/
/*    display: block;*/
/*    position: relative;*/
/*    padding-left: 35px;*/
/*    margin-bottom: 12px;*/
/*    cursor: pointer;*/
/*    font-size: 22px;*/
/*    -webkit-user-select: none;*/
/*    -moz-user-select: none;*/
/*    -ms-user-select: none;*/
/*    user-select: none;*/
/*}*/
/*.mimetika-policy .label-checkbox input {*/
/*    position: absolute;*/
/*    opacity: 0;*/
/*    cursor: pointer;*/
/*    height: 0;*/
/*    width: 0;*/
/*}*/

/*!* Create a custom checkbox *!*/
/*.mimetika-policy .label-checkbox .checkmark {*/
/*    position: absolute;*/
/*    top: -3px;*/
/*    left: 0;*/
/*    height: 19px;*/
/*    width: 19px;*/
/*    background-color: transparent;*/
/*    border: 1px solid white;*/
/*}*/

/*!* On mouse-over, add a grey background color *!*/
/*.mimetika-policy .label-checkbox:hover input ~ .checkmark {*/
/*    !*background-color: #ccc;*!*/
/*}*/

/*!* When the checkbox is checked, add a blue background *!*/
/*.mimetika-policy .label-checkbox input:checked ~ .checkmark {*/
/*    background-color: var(--gray);*/
/*}*/

/*!* Create the checkmark/indicator (hidden when not checked) *!*/
/*.mimetika-policy .label-checkbox .checkmark:after {*/
/*    content: "";*/
/*    position: absolute;*/
/*    display: none;*/
/*}*/

/*!* Show the checkmark when checked *!*/
/*.mimetika-policy .label-checkbox input:checked ~ .checkmark:after {*/
/*    display: block;*/
/*}*/

/*!* Style the checkmark/indicator *!*/
/*.mimetika-policy .label-checkbox .checkmark:after {*/
/*    left: 6px;*/
/*    top: 2px;*/
/*    width: 5px;*/
/*    height: 10px;*/
/*    border: solid white;*/
/*    border-width: 0 2px 2px 0;*/
/*    -webkit-transform: rotate(45deg);*/
/*    -ms-transform: rotate(45deg);*/
/*    transform: rotate(45deg);*/
/*}*/

.mimetika-checkbox.p-checkbox .p-checkbox-box{
    background: transparent;
    border-radius: 0;
    border: 1px solid white !important;
}
.mimetika-checkbox.p-checkbox .p-checkbox-box:hover{
    background: transparent;
    border-color: white;
}
.mimetika-checkbox.p-checkbox.p-highlight input,
.mimetika-checkbox.p-checkbox.p-highlight{
    background: var(--gray);
}
.mimetika-checkbox.p-checkbox.p-highlight .p-checkbox-box{
    border-color: var(--gray) !important;
}

`, "",{"version":3,"sources":["webpack://./src/css/policy.css"],"names":[],"mappings":";AACA,wCAAwC;AACxC,oCAAoC;AACpC,sBAAsB;AACtB,0BAA0B;AAC1B,0BAA0B;AAC1B,2BAA2B;AAC3B,uBAAuB;AACvB,uBAAuB;AACvB,iCAAiC;AACjC,8BAA8B;AAC9B,6BAA6B;AAC7B,yBAAyB;AACzB,IAAI;AACJ,2CAA2C;AAC3C,0BAA0B;AAC1B,kBAAkB;AAClB,uBAAuB;AACvB,iBAAiB;AACjB,gBAAgB;AAChB,IAAI;;AAEJ,iCAAiC;AACjC,gDAAgD;AAChD,0BAA0B;AAC1B,iBAAiB;AACjB,eAAe;AACf,oBAAoB;AACpB,mBAAmB;AACnB,qCAAqC;AACrC,+BAA+B;AAC/B,IAAI;;AAEJ,mDAAmD;AACnD,8DAA8D;AAC9D,kCAAkC;AAClC,IAAI;;AAEJ,4DAA4D;AAC5D,gEAAgE;AAChE,qCAAqC;AACrC,IAAI;;AAEJ,iEAAiE;AACjE,sDAAsD;AACtD,mBAAmB;AACnB,0BAA0B;AAC1B,qBAAqB;AACrB,IAAI;;AAEJ,wCAAwC;AACxC,sEAAsE;AACtE,sBAAsB;AACtB,IAAI;;AAEJ,sCAAsC;AACtC,sDAAsD;AACtD,iBAAiB;AACjB,gBAAgB;AAChB,kBAAkB;AAClB,oBAAoB;AACpB,2BAA2B;AAC3B,iCAAiC;AACjC,wCAAwC;AACxC,oCAAoC;AACpC,gCAAgC;AAChC,IAAI;;AAEJ;IACI,uBAAuB;IACvB,gBAAgB;IAChB,kCAAkC;AACtC;AACA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;AACA;;IAEI,uBAAuB;AAC3B;AACA;IACI,oCAAoC;AACxC","sourcesContent":["\n/* Hide the browser's default checkbox */\n/*.mimetika-policy .label-checkbox{*/\n/*    display: block;*/\n/*    position: relative;*/\n/*    padding-left: 35px;*/\n/*    margin-bottom: 12px;*/\n/*    cursor: pointer;*/\n/*    font-size: 22px;*/\n/*    -webkit-user-select: none;*/\n/*    -moz-user-select: none;*/\n/*    -ms-user-select: none;*/\n/*    user-select: none;*/\n/*}*/\n/*.mimetika-policy .label-checkbox input {*/\n/*    position: absolute;*/\n/*    opacity: 0;*/\n/*    cursor: pointer;*/\n/*    height: 0;*/\n/*    width: 0;*/\n/*}*/\n\n/*!* Create a custom checkbox *!*/\n/*.mimetika-policy .label-checkbox .checkmark {*/\n/*    position: absolute;*/\n/*    top: -3px;*/\n/*    left: 0;*/\n/*    height: 19px;*/\n/*    width: 19px;*/\n/*    background-color: transparent;*/\n/*    border: 1px solid white;*/\n/*}*/\n\n/*!* On mouse-over, add a grey background color *!*/\n/*.mimetika-policy .label-checkbox:hover input ~ .checkmark {*/\n/*    !*background-color: #ccc;*!*/\n/*}*/\n\n/*!* When the checkbox is checked, add a blue background *!*/\n/*.mimetika-policy .label-checkbox input:checked ~ .checkmark {*/\n/*    background-color: var(--gray);*/\n/*}*/\n\n/*!* Create the checkmark/indicator (hidden when not checked) *!*/\n/*.mimetika-policy .label-checkbox .checkmark:after {*/\n/*    content: \"\";*/\n/*    position: absolute;*/\n/*    display: none;*/\n/*}*/\n\n/*!* Show the checkmark when checked *!*/\n/*.mimetika-policy .label-checkbox input:checked ~ .checkmark:after {*/\n/*    display: block;*/\n/*}*/\n\n/*!* Style the checkmark/indicator *!*/\n/*.mimetika-policy .label-checkbox .checkmark:after {*/\n/*    left: 6px;*/\n/*    top: 2px;*/\n/*    width: 5px;*/\n/*    height: 10px;*/\n/*    border: solid white;*/\n/*    border-width: 0 2px 2px 0;*/\n/*    -webkit-transform: rotate(45deg);*/\n/*    -ms-transform: rotate(45deg);*/\n/*    transform: rotate(45deg);*/\n/*}*/\n\n.mimetika-checkbox.p-checkbox .p-checkbox-box{\n    background: transparent;\n    border-radius: 0;\n    border: 1px solid white !important;\n}\n.mimetika-checkbox.p-checkbox .p-checkbox-box:hover{\n    background: transparent;\n    border-color: white;\n}\n.mimetika-checkbox.p-checkbox.p-highlight input,\n.mimetika-checkbox.p-checkbox.p-highlight{\n    background: var(--gray);\n}\n.mimetika-checkbox.p-checkbox.p-highlight .p-checkbox-box{\n    border-color: var(--gray) !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
